import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, MapPin } from 'lucide-react';
const NAMES = ['Marcela G.', 'Hernán T.', 'Soledad P.', 'Lucía R.', 'Diego M.', 'Carla V.', 'Federico S.', 'Romina A.', 'Gastón L.', 'Florencia D.', 'Matías B.', 'Vanesa C.', 'Nicolás F.', 'Daniela O.', 'Pablo H.', 'Agustina N.', 'Leandro Q.', 'Mariana E.', 'Sebastián I.', 'Yamila U.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Resistencia', 'Posadas', 'San Juan', 'Bahía Blanca', 'Paraná', 'Quilmes', 'Avellaneda', 'Lomas de Zamora'];
const OFFERS = ['Kit Negocio de Oro', 'Megapack Negocio de Oro'];
const pick = <T,>(arr: T[]) => arr[Math.floor(Math.random() * arr.length)];
const randDelay = () => 40000 + Math.random() * 20000; // 40–60s
type Notice = {
  name: string;
  city: string;
  offer: string;
};
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const timeouts = useRef<ReturnType<typeof setTimeout>[]>([]);
  useEffect(() => {
    const clearAll = () => {
      timeouts.current.forEach(clearTimeout);
      timeouts.current = [];
    };
    const showOnce = () => {
      setNotice({
        name: pick(NAMES),
        city: pick(CITIES),
        offer: pick(OFFERS)
      });
      // visible ~5.5s
      const hideId = setTimeout(() => setNotice(null), 5500);
      // schedule next after random 40–60s from when this appeared
      const nextId = setTimeout(showOnce, randDelay());
      timeouts.current.push(hideId, nextId);
    };
    // first popup after a short initial delay
    const startId = setTimeout(showOnce, 6000);
    timeouts.current.push(startId);
    return clearAll;
  }, []);
  return <div className="pointer-events-none fixed bottom-4 left-4 z-[60] w-[calc(100%-2rem)] max-w-[300px] sm:bottom-6 sm:left-6" data-id="element-253">
      <AnimatePresence data-id="element-254">
        {notice && <motion.div key={`${notice.name}-${notice.city}`} initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto flex items-center gap-3 rounded-xl border border-gold/30 bg-card p-3 shadow-[0_8px_28px_rgba(0,0,0,0.5)]" data-id="element-255">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gold/15" data-id="element-256">
              <BadgeCheck className="h-5 w-5 text-gold" strokeWidth={2} data-id="element-257" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-258">
              <div className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.08em] text-gold" data-id="element-259">
                Compra verificada
              </div>
              <div className="truncate text-[12px] font-semibold text-white" data-id="element-260">
                {notice.name} compró el {notice.offer}
              </div>
              <div className="flex items-center gap-1 text-[10px] text-muted" data-id="element-261">
                <MapPin className="h-3 w-3 shrink-0 text-gold/70" data-id="element-262" />
                <span className="truncate" data-id="element-263">{notice.city} · ahora mismo</span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}